import { Transition } from '@uirouter/angularjs';
import { UserManager } from 'oidc-client';
import { ResetPasswordService, RESET_PASSWORD_SERVICE } from './reset-password.service';

import './reset-password.less';

export class ResetPasswordController {

    private userAndTicket: { username: string, id: string, ticket: string };
    private password: string;
    private confirm: string;

    private passwordSuccessfullyReset = false;

    get username() { return this.userAndTicket && this.userAndTicket.username ? this.userAndTicket.username : ""; }

    static $inject = [RESET_PASSWORD_SERVICE, "BoardWebAdminUserManager"];
    constructor(private resetPasswordService: ResetPasswordService, private userManager: UserManager) { }

    public submit() {
        return this.resetPasswordService.resetPassword(this.userAndTicket.id, this.password, this.confirm, this.userAndTicket.ticket).then(() => {
            this.passwordSuccessfullyReset = true;
        });
    }

    private gotoLogin() {
        this.userManager.signinRedirect();
    }
}


// WEBPACK FOOTER //
// ./app/reset-password/reset-password.controller.ts